import { render, staticRenderFns } from "./DatasetPanel.vue?vue&type=template&id=cb6acaee&scoped=true"
import script from "./DatasetPanel.vue?vue&type=script&lang=js"
export * from "./DatasetPanel.vue?vue&type=script&lang=js"
import style0 from "./DatasetPanel.vue?vue&type=style&index=0&id=cb6acaee&prod&lang=pcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6acaee",
  null
  
)

export default component.exports